module.exports = __webpack_public_path__ + "static/media/cloud_eveil.eb312686.png";